import { render, staticRenderFns } from "./GGanttChart.vue?vue&type=template&id=17012c6c&scoped=true"
import script from "./GGanttChart.vue?vue&type=script&lang=js"
export * from "./GGanttChart.vue?vue&type=script&lang=js"
import style0 from "./GGanttChart.vue?vue&type=style&index=0&id=17012c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17012c6c",
  null
  
)

export default component.exports